export default __webpack_public_path__ + "static/media/SZ08.e5a5d902.mp3";